export const toTitleCase = (str: string) => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

export const vehicleMakeFormatter = (rawText: string): string => {
    if (!rawText) return "";
    const cleanedValue = rawText.trim().replaceAll("/", "-");
    return rawText.length > 3 ? toTitleCase(cleanedValue.toLowerCase()) : cleanedValue;
};

export const capitaliseFirstLetter = (source: string | null): string | null => {
    if (source === null) return source;

    const locale = "en-GB";

    return source.length > 3
        ? source
              .toLocaleLowerCase(locale)
              .trim()
              .replace("/", "-")
              .replace(/\b\w/g, (char) => char.toUpperCase())
        : source.toUpperCase().replace("/", "-");
};
